<template>
  <div class="market-couponList-index">
    <Search :renderData="renderData" :formData="form" :labelWidth="100" @onSearch="onSearch" ></Search>
    <div class="fun-btn-box">
      <auth-button auth="market:coupon:template:create">
        <el-button type="primary" class="fun-btn mr10" @click="onAdd" >+ 创建优惠券</el-button>
      </auth-button>
      <auth-button auth="market:coupon:template:code:download">
        <el-button class="down-btn mr10" @click="onDownloadTemplate" :loading="downloadLoading" >下载券码导入模板</el-button>
      </auth-button>
      <selectCoupon></selectCoupon>
      <auth-button auth="market:coupon:share:data:export">
        <el-button class="down-btn mr10" @click="()=>{this.exportCouponDistributionDataDialog = true}" :loading="exportCouponDistributionDataLoading" >分享券埋点导出</el-button>
      </auth-button>
    </div>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #id="{ row }">{{ row.id }}</template>
      <template #templateCode="{ row }">{{ row.templateCode || '---' }}</template>
      <template #name="{ row }">{{ row.name }}</template>
      <template #type="{ row }">{{ row.type }}</template>
      <template #suitObject="{ row }">{{ row.suitObject == 'sku' ? '商品' : '店铺' }}</template>
      <template #external="{ row }">{{ row.external ? '是' : '否' }}</template>
      <template #supplier="{ row }">{{ row.supplier=="VoucherCenter"?"券中台投放":"闰土自制" }}</template>
      <template #brandName="{ row }">{{ row.brandName || '---' }}</template>
      <template #detail="{ row }">{{ row.detail }}</template>
      <template #require="{ row }">{{ row.require }}</template>
      <template #useTime="{ row }">{{ row.useTime }}</template>
      <template #costSettle="{ row }">{{ row.costSettle?'是':'否' }}</template>
      <template #commissionRatioSource="{ row }">{{ row.commissionRatioSource ? row.commissionRatioSource=="BuyStore"?'按售券店铺费率':'按核销店铺费率' : '---' }}</template>
      <template #useRangeType="{ row }">{{ row.useRangeType ? row.useRangeType : '---' }}</template>
      <template #totalStock="{ row }">{{ row.totalStock || '---' }}</template>
      <template #stock="{ row }">{{ row.stock || '---' }}</template>
      <template #issueType="{ row }">{{ issueTypeMap[row.issueType] || '---' }}</template>
      <template #remark="{ row }">
        <el-button v-if="row.remark" type="text" @click="onLookRemark(row)">查看使用须知</el-button>
        <span v-else>---</span>
      </template>
      <template #mallCostRate="{ row }">{{ row.mallCostRate }}%</template>
      <template #storeCostRate="{ row }">{{ row.storeCostRate }}%</template>
      <template #created="{ row }">{{ row.created ? $moment(row.created).format('YYYY/MM/DD HH:mm:ss') : '---' }}</template>
      <template #operatorName="{ row }">{{ row.operatorName }}</template>
      <template #operation="{ scope }">
        <auth-button auth="market:coupon:template:update" v-if="scope.row.supplier!='VoucherCenter'" >
          <el-button type="text" v-if="scope.row.disable" class="edit mr10" @click="onEdit(scope.row)">编辑</el-button>
        </auth-button>
        <el-button type="text" v-if="scope.row.supplier=='VoucherCenter'" class="edit mr10" @click="onEdit(scope.row)">编辑</el-button>
        <auth-button auth="market:coupon:template:discard"  v-if="scope.row.supplier!='VoucherCenter'">
          <el-button v-if="!scope.row.disable" class="del mr10" type="text" @click="onChangeStatus(scope.row)">停用</el-button>
          <el-button v-if="scope.row.disable" class="mr10" type="text" @click="onChangeStatus(scope.row)">启用</el-button>
        </auth-button>
        <auth-button auth="market:coupon:template:create" v-if="scope.row.supplier!='VoucherCenter'">
          <el-button type="text" class="edit mr10" @click="onEdit(scope.row, true)">复制</el-button>
        </auth-button>
        <auth-button v-if="scope.row.issueType === 'Stock' && scope.row.supplier!='VoucherCenter'" auth="market:coupon:template:code:import" >
          <el-button v-if="scope.row.external" type="text" class="edit" @click="onDownloadCodeBtn(scope.row)">下载券码</el-button>
          <el-button v-else type="text" class="edit" @click="onImportCode(scope.row)">券码导入</el-button>
        </auth-button>
        <auth-button auth="market:coupon:template:create">
          <el-button type="text" class="edit mr10" @click="goCodeStore(scope.row)" v-if="scope.row.supplier == 'Native' && scope.row.issueType == 'Stock'">查看码库</el-button>
        </auth-button>
      </template>
    </Table>
    <el-dialog :visible="isShowRemarkDialog" title="使用须知" :before-close="() => this.isShowRemarkDialog = false" width="30%">
      <div class="remark-box" v-html="currentRow.remark"></div>
    </el-dialog>
    <el-dialog :visible="showDownloadDialog" title="下载券码" width="25%">
      <el-form ref="downloadCouponCodeForm" :model="downloadCouponCodeForm" label-width="80px" >
        <el-form-item label="下载数量" prop="num" :rules="[{required: true, validator: checkNum}]">
          <el-input v-model="downloadCouponCodeForm.num" placeholder="请输入下载数量" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" maxLength="4" :disabled="downloadCouponCodeLoading" >
            <template slot="append">张</template>
          </el-input>
        </el-form-item>
        <el-form-item label="" prop="">
          <span class="prompt">下载数量不能超过5000</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showDownloadDialog = false">取 消</el-button>
        <el-button type="primary" @click="onDownloadCodeConfirm" :loading="downloadCouponCodeLoading">{{downloadCouponCodeLoading?'下载中...':'提 交'}}</el-button>
      </div>
    </el-dialog>
    <el-dialog v-if="exportCouponDistributionDataDialog" :visible="exportCouponDistributionDataDialog" title="分享券埋点导出" width="35%"  :show-close="false">
      <el-form ref="exportCouponDistributionDataFrom" :model="exportCouponDistributionDataFrom" label-width="80px" >
        <el-form-item label="选择时间" prop="dataTime">
          <el-date-picker
            v-model="exportCouponDistributionDataFrom.dataTime"
            type="datetimerange"
            range-separator=""
            format="yyyy/MM/dd HH:mm:ss"
            value-format="timestamp"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="" prop="" >
          <span class="input-remark">（*未选时间导出全部数据）</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="exportCouponDistributionDataCancel">取 消</el-button>
        <el-button type="primary" @click="exportCouponDistributionDataSubmit" :loading="exportCouponDistributionDataLoading">{{exportCouponDistributionDataLoading?'导出中...':'确 定'}}</el-button>
      </div>
    </el-dialog>
    <input v-if="showImport" ref="code-import-input" @change="importInputChange" class="code-import-input" type="file" accept=".xls, .xlsx">
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import tableList from '@/mixins/tableList'
import { api_postCouponList, api_putUpdateStatusCoupon, api_getCouponCodeImportTemplate, api_postCouponCodeImport, api_postDownloadCouponCode , api_getMarketCouponShareExport} from '@/api/market'
import { downFile } from "@/utils";
import { api_getConfig } from '@/api/common'
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
import SelectCoupon from "./components/selectCoupon";
export default {
  name: "marketCouponListIndex",
  mixins: [ tableList ],
  components: {
    AuthButton,
    Search,
    Table,
    SelectCoupon
  },
  data() {
    // 校验下载券码的下载数量
    const checkNum = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入下载数量'))
      } else if (parseInt(value) > 5000) {
        callback(new Error('下载数量不能超过5000'))
      } else {
        callback()
      }
    }

    return {
      renderData: [
        {
          label: "优惠券名称",
          placeholder: "请输入优惠券名称",
          type: "input",
          key: "name",
        },
        {
          label: "商场名称",
          type: "mall",
          key: "mallIds",
        },
        {
          label: "发放类型",
          placeholder: "请选择发放类型",
          type: "select",
          key: "issueType",
          option: [
            { label: '自动发放', value: 'Auto' },
            { label: '库存发放', value: 'Stock' }
          ],
        },
        {
          label: "券来源",
          placeholder: "请选择券来源",
          type: "select",
          key: "supplier",
          option: [
            { label: '闰土自制', value: 'Native' },
            { label: '券中台投放', value: 'VoucherCenter' }
          ],
        },
      ],

      form: {},
      tableThData: [
        { prop: "id", label: "ID", minWidth: "60", },
        { prop: "templateCode", label: "券模板编码", minWidth: "120", },
        { prop: "name", label: "优惠券名称", minWidth: "180", },
        { prop: "type", label: "优惠券类型", minWidth: "110", },
        { prop: "suitObject", label: "适用对象", minWidth: "110", },
        { prop: "external", label: "同步券中台", minWidth: "110", },
        { prop: "supplier", label: "券来源", minWidth: "120", },
        { prop: "brandName", label: "品牌", minWidth: "110", },
        { prop: "detail", label: "券优惠", minWidth: "120", },
        { prop: "require", label: "券门槛", minWidth: "180", },
        { prop: "useTime", label: "用券时间", minWidth: "280", },
        { prop: "useRangeType", label: "使用范围", minWidth: "160", },
        { prop: "totalStock", label: "总库存", minWidth: "100", },
        { prop: "stock", label: "可用库存", minWidth: "100", },
        { prop: "costSettle", label: "成本是否结算", minWidth: "120", },
        { prop: "commissionRatioSource", label: "结算费率配置", minWidth: "120", },
        { prop: "issueType", label: "发放类型", minWidth: "120", },
        { prop: "remark", label: "使用须知", minWidth: "120", },
        { prop: "created", label: "创建时间", minWidth: "180", },
        { prop: "operatorName", label: "操作人", minWidth: "120", },
        { prop: "operation", label: "操作", minWidth: "220", },
      ],
      downloadLoading: false,
      syncVoucherCenteLoading:false,
      couponTypeDataObj: {}, // 优惠券类型obj数据
      useRangeTypeDataObj: {
        'Generic': '通用',
        'Mall': '指定商场可用',
        'Store': '指定店铺可用',
      }, // 使用范围obj数据
      issueTypeMap: {
        'Auto': '自动发放',
        'Stock': '库存发放',
      },
      isShowRemarkDialog: false,
      currentRow: {},
      showImport: false,
      showDownloadDialog: false,
      downloadCouponCodeLoading: false,
      downloadCouponCodeForm: {},
      exportCouponDistributionDataDialog:false,
      exportCouponDistributionDataFrom:{dataTime:[]},
      exportCouponDistributionDataLoading:false,
      checkNum,
    };
  },
  created () {
    this.getCouponTypeData() // 获取优惠券类型数据
  },
  methods: {
    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({query: params})
      params.couponTypes && (params.couponTypes = [params.couponTypes]) // 券类型包装成list
      params.statuses && (params.statuses = [params.statuses]) // 券状态包装成list
      const data = await api_postCouponList(params)
      console.log('data: ', data);
      this.tableTrData = data.list || []
      this.total = data.count
      this.loading = false
      this.showImport = true
    },

    // 获取优惠券类型数据
    async getCouponTypeData() {
      const {couponType=[]} = await api_getConfig(['couponType'])
      let couponTypeObj = {}
      couponType.map(item => {
        couponTypeObj[item.name] = item.desc
      })
      this.couponTypeDataObj = couponTypeObj
    },

    // 查看使用须知
    onLookRemark(row) {
      this.currentRow = row
      this.isShowRemarkDialog = true
    },
    // 点击编辑
    async onEdit(row, copy='') {
      this.$router.push({
        path: `/market/couponList/create?id=${row.id}&copy=${copy}`
      });
    },
    // 点击创建按钮
    onAdd() {
      this.$router.push({
        path: "/market/couponList/create"
      });
    },

    // 更改券状态
      onChangeStatus(row) {
       this.$baseConfirm(
        row.disable ? '是否确认启用该优惠券？' : '是否停用该优惠券？',
         { title: '提示', type: 'warning', },
         async () => {
         await api_putUpdateStatusCoupon({id: row.id})
           this.$baseMessage('操作成功', 'success')
           this.getList()
         }

      )
    },
    // 下载券码导入模板
    async onDownloadTemplate() {
      this.downloadLoading = true
      try {
        let res = await api_getCouponCodeImportTemplate()
        downFile(res)
        this.downloadLoading = false
      } catch (err) {
        this.downloadLoading = false
      }
    },

    // 导入券码
    onImportCode(row) {
      this.currentRow = row
      this.$refs['code-import-input'].click()
    },

    // 上传input改变事件
    async importInputChange(e) {
      this.pageLoading = this.$loading({
        lock: true,
        text: "数据正在导入中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      try {
        const files = e.target.files
        let res = await api_postCouponCodeImport({
          id: this.currentRow.id,
          file: files[0]
        })
        this.$baseMessage(`${res.msg}`, 'success')
        this.showImport = false
        this.pageLoading.close();
        this.getList()
      } catch (err) {
        console.log('err: ', err);
        this.showImport = false
        this.pageLoading.close();
        this.getList()
      }
    },

    // 点击列表下载券码按钮
    onDownloadCodeBtn(row) {
      this.currentRow = row
      this.showDownloadDialog = true
    },

    // 下载券码提交
    async onDownloadCodeConfirm() {
      this.$refs.downloadCouponCodeForm.validate(async (valid) => {
        if (valid) {
          this.downloadCouponCodeLoading = true
          try {
            let res = await api_postDownloadCouponCode({
              templateId: this.currentRow.id,
              num: this.downloadCouponCodeForm.num
            })
            downFile(res)
            this.downloadCouponCodeLoading = false
            this.showDownloadDialog = false
          } catch (err) {
            this.downloadCouponCodeLoading = false
          }
        }
      })
    },
    async exportCouponDistributionDataSubmit(){
          this.exportCouponDistributionDataLoading = true
          let [actionTimeFrom , actionTimeTo]  = this.exportCouponDistributionDataFrom.dataTime?this.exportCouponDistributionDataFrom.dataTime:[]
            let params = {
                actionTimeFrom,
                actionTimeTo
            }
            console.log(params)
            try {
              let res = await api_getMarketCouponShareExport(params)
              downFile(res)
              this.exportCouponDistributionDataDialog = false
              this.exportCouponDistributionDataFrom = {
                dataTime:[]
              }
            } catch (error) {
              console.log(error)
            }
          this.exportCouponDistributionDataLoading = false
    },
    exportCouponDistributionDataCancel(){
      this.exportCouponDistributionDataDialog = false
      this.exportCouponDistributionDataFrom = {
        dataTime:[]
      }
    },

    // 查看码库
    goCodeStore(row) {
      this.$router.push({
        path: "/market/couponList/codeStore?templateId=" + row.id
      });
    },

  },
  watch: {
    showDownloadDialog (newValue) {
      this.downloadCouponCodeForm = {}
    }
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.market-couponList-index {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;

  .remark-box {
    width: 100%;
    min-height: 300px;
    max-height: 500px;
    overflow: auto;

    &::v-deep img {
      width: 100% !important;
    }
  }

  .fun-btn-box {
    margin-top: 20px;
    display: flex;
    justify-content: flex-start;
    .down-btn {
      padding: 0 10px;
    }
  }

  .code-import-input {
    height: 0px;
    visibility: hidden;
  }

  .copy {
    color: #05C8AF;
  }

  .del {
    color: #F74A4A;
  }
  .status{
    width: 6px;
    height: 6px;
    display: inline-block;
    border-radius: 50%;
    vertical-align: middle;
  }
  .dot-success{
    background: #05c8af;
  }

  .dot-clear {
    background: #F74A4A;
  }

  .dot-ing {
    background: #3775FF;
  }

  .dot-new {
    background: #ccc;
  }

  .input-remark {
    height: 17px;
    line-height: 17px;
    font-size: 12px;
    color: #999999;
  }
}
</style>
